import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取司机-车辆列表（包括已封禁状态）
 * @param data
 */
export const getDriverOrCarList = (data) => {
  return request({
    url: env.ferryUrl + '/common/driverOrCar/list',
    method: 'POST',
    data
  })
}

/**
 * 获取角色列表
 * @param params
 */
export const getRoleList = (params) => {
  return request({
    url: env.ferryUrl + '/role/list',
    method: 'get',
    params
  })
}

/**
 * 获取当前登录用户所属供应商及下属供应商（可包括已删除供应商）
 * @param params
 */
export const getMerchantList = (params) => {
  return request({
    url: env.ferryUrl + '/common/merchant/list',
    method: 'get',
    params
  })
}
/**
 *  获取所有可用供应商
 */
export const getAllMerchantList = () => {
  return request({
    url: env.ferryUrl + '/orderAdmin/getIntercityMerchantList',
    method: 'GET'
  })
}
/**
 * 获取当前登录用户线路列表(包括已下架线路)
 * @param params
 */
export const getLineList = (params) => {
  return request({
    url: env.ferryUrl + '/common/line/list',
    method: 'get',
    params
  })
}

/**
 *  获取所有可用线路信息
 */
export const getAllLineList = () => {
  return request({
    url: env.ferryUrl + '/orderAdmin/getLineList',
    method: 'GET'
  })
}

/**
 * 获取公司业务类型
 * @param params
 */
export const getBizType = (params) => {
  return request({
    url: env.ferryUrl + '/merchant/getBizType',
    method: 'get',
    params
  })
}
/**
 * 获取省市区地址 JSON文件
 */
export const getDistinct = () => {
  return request({
    url: 'https://webapi.amap.com/ui/1.1/ui/geo/DistrictExplorer/assets/d_v1/country_tree.json',
    method: 'get',
    headers: {
      'X-THIRD-PARTY': true
    }
  })
}
/**
 * 获取站点
 * @param params
 */
export const getStationList = () => {
  return request({
    url: env.ferryUrl + '/orderAdmin/getStationInfoList',
    method: 'get'
  })
}
/**
 * 获取用户（注册用户、实际乘车人）
 *
 */
export const getPassengerList = (params) => {
  return request({
    url: env.ferryUrl + '/common/user/list',
    method: 'get',
    params
  })
}
